/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetContactsResponse,
} from '../models/index';
import {
    GetContactsResponseFromJSON,
    GetContactsResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class ContactsApi extends runtime.BaseAPI {

    /**
     * Get contacts for all contracts of the current user
     */
    async getAllContactsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetContactsResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contacts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContactsResponseFromJSON));
    }

    /**
     * Get contacts for all contracts of the current user
     */
    async getAllContactsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetContactsResponse>> {
        const response = await this.getAllContactsGetRaw(initOverrides);
        return await response.value();
    }

}
